import React, { useEffect, useState } from 'react'

import {
  TableContainerStyled,
  TableStyled,
  TableFooter,
  TableCellStyled,
  TableRowStyled,
  TableBodyStyled,
  TableHeadStyled
} from 'components'
import { useLoading } from 'hooks'
import { useFormContext, UseFormReturn } from 'react-hook-form'
import {
  IClaimantHistoriesItems,
  DjurServices
} from 'services/NGT/DjurServices'
import { FORMAT } from 'utils'

import { useDjurService } from '../../../../../../context'

const TableClaimant: React.FC = () => {
  const { state } = useDjurService()
  const { setLoading } = useLoading()

  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [pageCount, setPageCount] = useState<number>(0)
  const [paginatedTable, setPaginatedTable] = useState<
    IClaimantHistoriesItems[]
  >([])

  const form: UseFormReturn<any, object> & { errors?: any } = useFormContext()

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(1)
  }

  const getTableDataWithPagination = () => {
    setLoading('loading')

    DjurServices()
      .getInfoAtendimentoDjur({
        cpfReclamante: state?.djurTarget?.cpfReclamante || FORMAT.unMask(form.getValues('cpfReclamante')),
        flHistoricoReclamante: true,
        idAtendimentoDjur: state?.djurTarget?.idAtendimentoDjur || 0,
        nuProcesso: state?.djurTarget?.processoReclamante || '',
        pageNumber: page,
        pageSize: rowsPerPage
      })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Erro ao obter dados do Atendimento Djur')
        }

        if (response?.data?.historicoReclamante) {
          setPaginatedTable(response.data.historicoReclamante.items)
          setPageCount(response.data.historicoReclamante.pageCount)
        } else {
          setPaginatedTable([])
          setPageCount(0)
        }

        setLoading('idle')
      })
  }

  useEffect(() => {
    getTableDataWithPagination()
  }, [])

  useEffect(() => {
    getTableDataWithPagination()
  }, [page, rowsPerPage])

  useEffect(() => {
    const isfirstmount = (state.refreshHistoricoReclamante === null) as boolean

    if (!isfirstmount) {
      setPage(1)
      getTableDataWithPagination()
    }
  }, [state.refreshHistoricoReclamante])

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="center">
                CPF/CNPJ/Cód.Fornecedor
              </TableCellStyled>
              <TableCellStyled align="center">Fornecedor</TableCellStyled>
              <TableCellStyled align="center">Contrato</TableCellStyled>
              <TableCellStyled align="center">Centro</TableCellStyled>
              <TableCellStyled align="center">Competência</TableCellStyled>
              <TableCellStyled align="center">Status</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {paginatedTable.length > 0 &&
              paginatedTable?.map((row, index) => (
                <TableRowStyled key={index + row.contrato}>
                  <TableCellStyled align="center">
                    {FORMAT.formatCdDocto(row.cnpj.trim())}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.fornecedor}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.contrato}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.nmCentro}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {FORMAT.competencia(row.competencia)}
                  </TableCellStyled>
                  <TableCellStyled align="center">{row.status}</TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        totalItems={pageCount}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="online"
      />
    </>
  )
}

export default TableClaimant
